import axios, { CancelTokenSource } from 'axios'
import {
  IContactFilters,
  IManageBoardContact,
} from 'Modules/Communication/Contacts/shared/models/Contacts'
import { IUpdateContactModel } from 'Modules/HousingAssociation/OurCompany/shared/models/Unit'
import { IFilterModel } from 'shared/models/List'

const BASE_URL = 'client/clients/'

/**
 * CONTACTS
 */

export const getResidentContacts = (
  id: string,
  filters: IContactFilters,
  source: CancelTokenSource
) =>
  axios.post(`${BASE_URL}${id}/contacts/query`, filters, {
    cancelToken: source?.token,
  })

export const getContactUnits = (id: string, nameId: string) =>
  axios.get(`${BASE_URL}${id}/contacts/${nameId}/units`)

export const getOtherContacts = (
  id: string,
  filters: IFilterModel,
  source: CancelTokenSource
) =>
  axios.post(`${BASE_URL}${id}/othercontacts/query`, filters, {
    cancelToken: source?.token,
  })

export const getBoardContacts = (
  id: string,
  filters: IFilterModel,
  source: CancelTokenSource
) =>
  axios.post(`${BASE_URL}${id}/boardcontacts/query`, filters, {
    cancelToken: source?.token,
  })

export const getBoardContact = (id: string, contactId: string) =>
  axios.get(`${BASE_URL}${id}/boardcontacts/${contactId}`)

export const addBoardContact = async (
  id: string,
  contact: IManageBoardContact
) => {
  try {
    return await axios.post(`${BASE_URL}${id}/boardcontacts`, contact)
  } catch (error) {
    console.error('addBoardContacti API error', error)
    throw error
  }
}

export const updateBoardContact = async (
  id: string,
  contactId: string,
  contact: IManageBoardContact
) => {
  try {
    return await axios.put(
      `${BASE_URL}${id}/boardcontacts/${contactId}`,
      contact
    )
  } catch (error) {
    console.error('updateBoardContact API error', error)
    throw error
  }
}

export const deleteBoardContact = (id: string, contactId: string) =>
  axios.delete(`${BASE_URL}${id}/boardcontacts/${contactId}`)

export const updateOwner = (updateOwnersPayload: {
  clientId: string
  nameId: string
  owner: IUpdateContactModel
}) => {
  return axios.put(
    `${BASE_URL}${updateOwnersPayload.clientId}/contacts/${updateOwnersPayload.nameId}`,
    updateOwnersPayload.owner
  )
}
